export const IT_TEMPLATES_COLLECTION_NAME = 'Templates';
export const IT_TEMPLATES_ID_PREFIX = '__tpl__:';

export const IT_THEME_KEY = 'it:theme';
export const IT_RESP_WIDTH_KEY = 'it:respWidth';
export const IT_LAST_INTEGRATION_KEY = 'it:lastIntegrationId';

export const keyLastCollection = (integrationId: number) => `it:lastCollectionId:${integrationId}`;
export const keyVars = (integrationId: number) => `it:postman:variables:${integrationId}`;
export const keyHistory = (integrationId: number) => `it:postman:history:${integrationId}`;
